const riveHeaderAnimationObject = {
    instance: null,
    status: -1,
    timer: null,
    initialize: function () {
        if (this.status === -1) {
            this.status = 0;

            const elmPhone = document.getElementById('welcome-phone_canvas');
            elmPhone.setAttribute('width', (elmPhone.clientWidth * 2).toString());
            elmPhone.setAttribute('height', (elmPhone.clientHeight * 2).toString());

            this.instance = new rive.Rive({
                src: document.location.origin + '/i/instaforex/rive/header-animation.riv',
                canvas: elmPhone,
                artboard: 'header-animation',
                stateMachines: 'state',
                layout: new rive.Layout({
                    fit: rive.Fit.Cover,
                }),
                autoplay: false,
                onload: this.checkReadyRive.bind(this)
            });
        }
    },
    play: function () {
        this.instance.play();
    },
    checkReadyRive: function () {
        clearTimeout(this.timer);

        if (this.instance.readyForPlaying) {
            this.status = 1;
            main.setLoaderPercent(1);
        } else {
            this.timer = setTimeout(this.checkReadyRive.bind(this), 500);
        }
    },
}
